import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Framework from "@/pages/Framework";
import GetInvolved from "@/pages/GetInvolved";
import Programs from "@/pages/Programs";
import ProgramDetail from "@/pages/ProgramDetail";
import Partner from "@/pages/Partner";
import Support from "@/pages/Support";
import Contact from "@/pages/Contact";
import Testimonials from "@/pages/Testimonials";
import SummerCamp from "@/pages/SummerCamp";
import Afterschool from "@/pages/Afterschool";
import Homeschool from "@/pages/Homeschool";
import Survey from "@/pages/Survey";
import AdminDashboard from "@/pages/AdminDashboard";
import Faq from "@/components/Faq";
import DonationSuccess from "@/pages/DonationSuccess";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/framework" element={<Framework />} />
            <Route path="/get-involved" element={<GetInvolved />} />
            <Route path="/programs" element={<Programs />} />
            <Route path="/programs/:slug" element={<ProgramDetail />} />
            <Route path="/partner" element={<Partner />} />
            <Route path="/support" element={<Support />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/summer-camp" element={<SummerCamp />} />
            <Route path="/afterschool" element={<Afterschool />} />
            <Route path="/homeschool" element={<Homeschool />} />
            <Route path="/survey" element={<Survey />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/donation-success" element={<DonationSuccess />} />
          </Routes>
        </Layout>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
